export default {
  "pl": {
    "window": {
      "app": "Aplikacja",
      "customersDashboard": "Panel główny",
      "customersDecisionDocuments": "Decyzja",
      "customersDecisionProposals": "Oferty związane z decyzjami",
      "customersDecisionTickets": "Decyzja",
      "customersDecisionTicketsShow": "Decyzja",
      "customersDecisions": "Decyzje",
      "customersDocuments": "Dokumenty",
      "customersDocumentsAll": "Przegląd dokumentów",
      "customersDocumentsFolder": "Kategoria dokumentu",
      "customersDocumentsFolders": "Kategorie dokumentów",
      "customersInspirationLists": "Inspiracje",
      "customersInspirationListsShow": "Inspiracje",
      "customersInstallmentTerms": "Warunki dotyczące rat",
      "customersIssues": "Problemy",
      "customersProjectInformation": "Informacje o projekcie",
      "customersQuestionLists": "FAQ",
      "customersQuestionListsShow": "FAQ",
      "customersRoot": "Aplikacja",
      "customersRootSettingsProfile": "Ustawienia",
      "customersSettingsProfile": "Ustawienia",
      "customersTickets": "Rozmowy",
      "customersTicketsNew": "Nowa rozmowa",
      "customersTicketsShow": "Rozmowa",
      "employeesClientContacts": "Kontakty",
      "employeesClientContactsNewCustomer": "Nowy klient",
      "employeesClientContactsNewEmployee": "Nowy członek zespołu",
      "employeesClientContactsNewPartner": "Nowy partner",
      "employeesClientDashboard": "Panel główny",
      "employeesClientProjects": "Projekty",
      "employeesClientProjectsNew": "Nowy projekt",
      "employeesClientTickets": "Rozmowy",
      "employeesClientTicketsNew": "Nowa rozmowa",
      "employeesClientTicketsShow": "Rozmowa",
      "employeesProjectActivity": "Aktywność",
      "employeesProjectAnnouncements": "Aktualności",
      "employeesProjectDecisionActivity": "Aktywność",
      "employeesProjectDecisionDocuments": "Decyzja",
      "employeesProjectDecisionProposalTemplate": "Szablony propozycji",
      "employeesProjectDecisionProposals": "Oferty",
      "employeesProjectDecisionReminders": "Przypomnienia",
      "employeesProjectDecisionTickets": "Rozmowy",
      "employeesProjectDecisionTicketsShow": "Rozmowa",
      "employeesProjectDecisionTypeNew": "Nowa decyzja",
      "employeesProjectDecisionTypes": "Decyzje",
      "employeesProjectDecisions": "Decyzje",
      "employeesProjectDecisionsEdit": "Decyzje",
      "employeesProjectDecisionsNew": "Nowa decyzja",
      "employeesProjectDocuments": "Dokumenty",
      "employeesProjectInformationPageActivity": "Aktywność",
      "employeesProjectInformationPageDecisions": "Decyzje",
      "employeesProjectInformationPageDocuments": "Dokumenty",
      "employeesProjectInformationPageInformation": "Informacje",
      "employeesProjectInformationPageInstallments": "Raty",
      "employeesProjectInformationPageLevels": "Poziomy",
      "employeesProjectInformationPageMilestones": "Kamienie milowe",
      "employeesProjectInformationPageSpaces": "Przestrzenie",
      "employeesProjectInformationPageSurveys": "Ankiety",
      "employeesProjectInformationPageTasks": "Zadania",
      "employeesProjectInstallmentNew": "Nowa rata",
      "mployeesProjectInstallmentGroups": "Dane finansowe",
      "employeesProjectInstallmentGroup": "Dane finansowe",
      "employeesProjectInstallmentGroupNew": "Nowy warunek dotyczący rat",
      "employeesProjectInstallmentGroupsMatrix": "Raty",
      "employeesProjectIssueListTypeIssues": "Lista problemów - Wszystkie problemy",
      "employeesProjectIssueListTypeNew": "Nowy typ listy problemów",
      "employeesProjectIssueListTypeUnits": "Lista problemów - przegląd jednostki",
      "employeesProjectIssueListTypes": "Listy problemów",
      "employeesProjectIssueListUnitDocuments": "Unit Issues - Documents",
      "employeesProjectIssueListUnitIssues": "Unit issues",
      "employeesProjectIssueListUnitTickets": "Unit Issues - Tickets",
      "employeesProjectIssueListsNew": "Nowe problemy",
      "employeesProjectQuestionLists": "FAQ",
      "employeesProjectQuestionListsShow": "FAQ",
      "employeesProjectSurveyNew": "Nowa ankieta",
      "employeesProjectSurveyTypeNew": "Nowa ankieta",
      "employeesProjectSurveyTypes": "Ankiety",
      "employeesProjectSurveys": "Ankieta",
      "employeesProjectTickets": "Rozmowy",
      "employeesProjectTicketsNew": "Nowa rozmowa",
      "employeesProjectTicketsShow": "Rozmowy",
      "employeesProjectTodoLists": "Zadania",
      "employeesSettingsClientAftercare": "Opieka postpenitencjarna",
      "employeesSettingsClientInformation": "Administrator",
      "employeesSettingsClientIntegrations": "Integracje",
      "employeesSettingsProfile": "Profil",
      "level": "Poziom",
      "partnersClientProjects": "Projekty",
      "partnersProjectDecisionDocuments": "Dokumenty",
      "partnersProjectDecisionProposals": "Oferty",
      "partnersProjectDecisionTickets": "Rozmowy",
      "partnersProjectDecisionTicketsShow": "Rozmowa",
      "partnersProjectDecisionTypesItems": "Decyzje",
      "partnersProjectDecisions": "Decyzje",
      "partnersProjectDocuments": "Dokumenty",
      "partnersProjectDocumentsUnit": "Dokumenty",
      "partnersProjectIssueListTypeIssues": "Lista problemów - Wszystkie problemy",
      "partnersProjectIssueListTypeUnits": "Lista problemów - przegląd jednostki",
      "partnersProjectIssueListTypes": "Listy problemów",
      "partnersProjectIssueListUnitDocuments": "Unit Issues - Documents",
      "partnersProjectIssueListUnitIssues": "Unit issues",
      "partnersProjectIssueListUnitTickets": "Unit Issues - Tickets",
      "partnersSettingsProfile": "Profil",
      "root": "Aplikacja"
    }
  }
}
